/**
 * Routes limited to `ADMIN` and `TEAM`.
 * `/admin` is the admin area. `/craft` is bot craft, the same screen as `/admin/bot-craft`.
 * @param path Router path, with or without a query string.
 * @returns Whether the path is limited to privileged roles.
 */
export function isPrivilegedAppPath(path: string): boolean {
  const pathname = path.split('?')[0] ?? path;
  return pathname === '/craft' || pathname.startsWith('/craft/') || pathname.startsWith('/admin');
}
